import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  width: 90%;
  background-color: ${({ theme }) => theme.THEME.background};
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;

  @media (min-width: 1025px) {
    width: 50%;
  }
`;

export const Title = styled.h1`
  font-family: "Sora", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 34}px;
  color: ${({ theme }) => theme.THEME.neonBlue};
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 3}px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 10}px;
    text-align: center;
  }
`;

export const FieldLabel = styled.p`
  font-family: "Sora", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 23}px;
  color: ${({ theme }) => theme.THEME.grayText};
  margin: 0;
  white-space: nowrap;
  flex: 0 0 auto;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6.5}px;
  }
`;

export const FieldValue = styled.p`
  font-family: "Inter", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  color: ${({ theme }) => theme.THEME.white};
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 12px 16px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 4}px;
  gap: 10px;

  &:hover {
    transform: scale(1);
    box-shadow: 0 0 12px rgba(255, 255, 255, 0.1);
  }

  width: ${({ theme }) => theme.CONSTANTS.XW * 80}px;

  @media (min-width: 1025px) {
    width: ${({ theme }) => theme.CONSTANTS.XW * 35}px;
  }
`;

export const ProfileImageWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 3}px;
  display: flex;
  justify-content: center;
`;

export const ProfileImage = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid ${({ theme }) => theme.THEME.neonBlue};
`;
